module.exports = __webpack_public_path__ + "img/gms_8.a603a68e.png";